import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="w-full bg-primary-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-background-50 flex items-center justify-center">
                <i className="ri-play-circle-fill text-xl"></i>
              </span>
              <span className="text-base font-heading font-bold text-background-50">中文字幕一区二区三区四虎在线</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-400 max-w-lg">
              专注中文字幕影视在线播放（演示），汇集电影、电视剧、综艺等丰富内容，帮助你快速查找并流畅观看带中文字幕的高清影视作品。本站为前端演示站点，所有影视内容皆为演示数据，播放器区域暂不支持真实播放。
            </p>
            <div className="mt-4 flex items-center gap-3">
              <span className="w-9 h-9 rounded-md bg-primary-800 flex items-center justify-center text-background-200">
                <i className="ri-mail-line"></i>
              </span>
              <span className="text-sm text-background-300">contact@zhongwenzimu.example.com</span>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-3">频道导航</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-accent-400 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category/movie" className="hover:text-accent-400 transition-colors cursor-pointer">电影频道</Link></li>
              <li><Link to="/category/tv" className="hover:text-accent-400 transition-colors cursor-pointer">电视剧频道</Link></li>
              <li><Link to="/category/variety" className="hover:text-accent-400 transition-colors cursor-pointer">综艺频道</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-3">帮助与支持</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/search" className="hover:text-accent-400 transition-colors cursor-pointer">搜索影视</Link></li>
              <li><Link to="/about" className="hover:text-accent-400 transition-colors cursor-pointer">关于我们</Link></li>
              <li><Link to="/about" className="hover:text-accent-400 transition-colors cursor-pointer">免责声明</Link></li>
              <li><Link to="/about" className="hover:text-accent-400 transition-colors cursor-pointer">联系我们</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
          <p>© 2026 中文字幕一区二区三区四虎在线 · 本站内容仅用于学习演示</p>
          <p>影视数据为演示内容，播放器暂不支持真实播放</p>
        </div>
      </div>
    </footer>
  );
}